<template>
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <GuardianNotification />
  </div>
</template>

<script>
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import GuardianNotification from '@src/router/views/settings/notifications/guardian.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import UITabs from '@src/components/UiElements/UITabs.vue'

export default {
  name: 'Settings',
  components: {
    UITabs,
    NoRecordFound,
    GuardianNotification,
  },

  page: {
    title: 'Features Settings',
  },
  data() {
    return {
      FEATURES_TABS,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },
}
</script>
